import type {
  NotificationsReferential,
  NotificationsType,
} from "./referential-notifications.type";

export const filterNotificationByType = (
  notifications: NotificationsReferential[],
  type: NotificationsType
) => {
  return notifications.filter((notification) => notification.type === type);
};

export const groupNotificationsByType = (
  notifications: NotificationsReferential[]
) => {
  return notifications.reduce<
    Record<NotificationsType, NotificationsReferential[]>
  >(
    (acc, item) => {
      if (acc[item.type]) {
        acc[item.type].push(item);
      }
      return acc;
    },
    {
      generic: [],
      "transition-intervention": [],
      "transition-observation": [],
      module: [],
    }
  );
};
